export default __webpack_public_path__ + "alberta-document.ef8b0d42f80a1626081a.svg";